import axios from "axios";

const SERVER_URL = process.env.REACT_APP_SERVER_URL;
const BASE_URL = `${SERVER_URL}/ratings`;

async function submitRatings({
  token,
  feature,
  rating,
  nps,
  unhappyFeedback,
  recommendations,
  ref,
}) {
  axios.defaults.headers.common["Authorization"] = `Token ${token}`;
  try {
    const { data } = await axios.post(`${BASE_URL}`, {
      feature,
      rating,
      nps,
      unhappyFeedback,
      recommendations,
      ref,
    });
    return data;
  } catch (e) {
    throw e;
  }
}

const RatingsService = {
  submitRatings,
};

export default RatingsService;
